import * as React from "react";
import { Trash2 } from "lucide-react";
import { MediaPlayer } from "../MediaPlayer";
import { Media } from "@/services/bedrock";

interface OwnProps {
  id: number;
  src: Media;
  handleRemove: (id: number) => void;
}

export const MediaItem: React.FC<OwnProps> = ({ id, src, handleRemove }) => {
  return (
    <div className="relative w-[130px] h-[130px] shrink-0 group">
      <button
        type="button"
        className="absolute top-1.5 right-1.5 z-10 p-1.5 rounded-full bg-destructive text-destructive-foreground opacity-0 group-hover:opacity-100 hover:scale-105 transition-all shadow-md"
        onClick={() => handleRemove(id)}
      >
        <Trash2 className="size-3" />
      </button>
      <div className="w-full h-full rounded-xl overflow-hidden border border-border bg-muted/20 flex items-center justify-center p-2">
        <MediaPlayer media={src} />
      </div>
    </div>
  );
};
